export default {
    state: {
        path: [],
        searchMode: false,
        moveLoading: false,
        copyLoading: false,
    },
    getters: {},
    mutations: {
        setCloudFileStatus(state, obj) {
            let key = Object.keys(obj);
            for (let item of key) {
                state[item] = obj[item];
            }
        },
    },
};
